const navbarData = [
  {
    id: 'nav-home',
    name: 'home',
    href: '/',
  },
  {
    id: 'nav-story',
    name: 'my story',
    href: '#aboutme',
  },
  {
    id: 'nav-skills',
    name: 'my skills',
    href: '#skillsets',
  },
  {
    id: 'nav-works',
    name: 'my works',
    href: '#works',
    className: 'link',
  },
  {
    id: 'nav-contact',
    name: 'contact',
    href: '#contact',
  },
];

export default navbarData;
